import type { ApiClient, ExpenseList, MaintenanceList } from '@elite-residence/api-client';
import { type Failure, failureOf } from '../ui/ui';

export async function loadMaintenance(
  client: ApiClient,
  signal?: AbortSignal,
): Promise<MaintenanceList['maintenance']> {
  const rows: MaintenanceList['maintenance'][number][] = [];
  const cursors = new Set<string>();
  let cursor: string | undefined;
  do {
    const response = await client.listMaintenance(
      { query: { limit: '500', ...(cursor ? { cursor } : {}) } },
      signal ? { signal } : {},
    );
    if (response.status !== 200) throw new Error('maintenance_unavailable');
    rows.push(...response.body.maintenance);
    cursor = response.body.nextCursor ?? undefined;
    if (cursor) {
      if (cursors.has(cursor)) throw new Error('maintenance_cursor_repeated');
      cursors.add(cursor);
    }
  } while (cursor);
  return rows;
}

export async function loadExpenses(
  client: ApiClient,
  signal?: AbortSignal,
): Promise<{ ok: true; transactions: ExpenseList['transactions'] } | { ok: false; failure: Failure }> {
  const transactions: ExpenseList['transactions'][number][] = [];
  const cursors = new Set<string>();
  let cursor: string | undefined;
  do {
    const response = await client.listExpenses(
      { query: { limit: '500', ...(cursor ? { cursor } : {}) } },
      signal ? { signal } : {},
    );
    if (response.status !== 200) return { ok: false, failure: failureOf(response) ?? { status: response.status } };
    transactions.push(...response.body.transactions);
    cursor = response.body.nextCursor ?? undefined;
    if (cursor) {
      if (cursors.has(cursor)) throw new Error('expenses_cursor_repeated');
      cursors.add(cursor);
    }
  } while (cursor);
  return { ok: true, transactions };
}
